var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeumiLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 158,
    height: 61,
    viewBox: "0 0 158 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1003_227)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.2168 33.0122C45.5593 33.0122 41.6458 26.9784 31.5792 26.9784C21.5126 26.9784 17.8895 33.0122 10.9415 33.0122H0.217529V2.82039C0.22449 2.44292 0.305151 2.07051 0.454898 1.72446C0.604646 1.37842 0.820558 1.06551 1.09029 0.803601C1.36001 0.541693 1.67828 0.335916 2.02691 0.198037C2.37553 0.0601581 2.74768 -0.00712316 3.12211 2.7345e-05H60.0362C60.4103 -0.00711791 60.7821 0.0602176 61.1303 0.19819C61.4784 0.336162 61.7962 0.542054 62.0653 0.804059C62.3344 1.06606 62.5496 1.37904 62.6985 1.72504C62.8475 2.07104 62.9272 2.44327 62.9332 2.82039V33.0122H52.2321H52.2168Z",
    fill: "#4D8FF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.11427 60.7611C2.73985 60.7683 2.3677 60.701 2.01907 60.5631C1.67045 60.4252 1.35218 60.2194 1.08245 59.9575C0.812723 59.6956 0.596834 59.3827 0.447086 59.0367C0.297338 58.6906 0.216678 58.3182 0.209717 57.9408V35.9712H62.9253V57.9408C62.9194 58.3179 62.8396 58.6901 62.6907 59.0361C62.5418 59.3821 62.3266 59.6951 62.0575 59.9571C61.7884 60.2191 61.4706 60.425 61.1224 60.5629C60.7742 60.7009 60.4025 60.7683 60.0284 60.7611H3.11427Z",
    fill: "#070762"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1337 41.8123V52.5466L77.5781 53.2478V41.8123H82.1337Z",
    fill: "#070762"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.119 51.2134C106.119 59.1967 101.449 62.8416 94.4934 60.0906L95.4336 56.515C99.8975 58.48 102.145 56.3918 102.145 51.2519C102.145 47.6147 100.325 45.4571 97.8948 45.4571C95.4642 45.4571 93.882 47.6455 92.7049 52.1766L90.4576 60.8535H86.2613L88.6003 52.115L85.26 41.843H89.4181L90.878 46.821C92.2157 43.5537 94.6463 41.5579 97.7114 41.5579C102.779 41.5579 106.119 45.5495 106.119 51.2519",
    fill: "#070762"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.519 41.8123H109.964V60.8227H114.519V41.8123Z",
    fill: "#070762"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.657 60.63V60.8149H132.581L125.129 51.3135C123.18 52.6081 122.27 55.336 122.431 60.8149H117.845C117.684 53.502 119.373 50.1114 122.79 48.3699L117.814 41.9971V41.8044H122.859L130.311 51.3135C132.26 50.0112 133.17 47.2602 133.009 41.8044H137.596C137.756 49.1251 136.067 52.4848 132.65 54.2572L137.657 60.63Z",
    fill: "#070762"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.485 35.7322V45.5803H151.415L145.53 60.6608V60.8149H150.376L157.438 42.2206V41.8121H145.04V35.7322H140.485Z",
    fill: "#070762"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1003_227"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 157.229,
    height: 61,
    fill: "white",
    transform: "translate(0.209717)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeumiLogo);
export default __webpack_public_path__ + "static/media/leumi-logo.f3a30b9ab8aee45dc1050621011d4a7d.svg";
export { ForwardRef as ReactComponent };